export enum DocProcessingStatus {
  None = "none",
  InProgress = "in-progress",
  Success = "success",
  Error = "error",
  Ineligible = "ineligible",
}
